/**
 * RefreshTokenModelDto for Auth/Me endpoint
 */
export class RefreshTokenModelDto {
  
  accessToken = '';
  

  setData(data: Partial<RefreshTokenModelDto>): void {
    this.accessToken = data.accessToken ?? '';
    
  }

  clear(): void {
    
    this.accessToken = '';
    
  }
}

